import { render, staticRenderFns } from "./GameConfigWizard.vue?vue&type=template&id=19a03f90&scoped=true"
import script from "./GameConfigWizard.vue?vue&type=script&lang=js"
export * from "./GameConfigWizard.vue?vue&type=script&lang=js"
import style0 from "./GameConfigWizard.vue?vue&type=style&index=0&id=19a03f90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a03f90",
  null
  
)

export default component.exports